export const RecipeType = {
    Breakfast: "Breakfast",
    Snack: "Snack",
    Appetizer: "Appetizer",
    Main: "Main",
    Side: "Side",
    Soup: "Soup",
    Bread: "Bread",
    SaucesAndSeasonings: "Sauces and Seasonings",
    Dessert: "Dessert",
    Drink: "Drink"
} as const;
export type RecipeType = (typeof RecipeType)[keyof typeof RecipeType];

export const RecipeTypePathMap: Record<string, RecipeType> = {
    breakfast: RecipeType.Breakfast,
    snack: RecipeType.Snack,
    appetizer: RecipeType.Appetizer,
    main: RecipeType.Main,
    side: RecipeType.Side,
    soup: RecipeType.Soup,
    bread: RecipeType.Bread,
    "sauces-and-seasonings": RecipeType.SaucesAndSeasonings,
    dessert: RecipeType.Dessert,
    drink: RecipeType.Drink
};

export function recipeTypeFromPath(pathname = ""): RecipeType | undefined {
    const pathSegments = pathname.split("/");
    const typePath = pathSegments[pathSegments.length - 1];
    if (!typePath) return undefined;
    return RecipeTypePathMap[typePath];
}

export function recipeTypeToPath(type?: RecipeType): string | undefined {
    if (!type) return undefined;
    const entry = Object.entries(RecipeTypePathMap).find(([, v]) => v === type);
    return entry ? entry[0] : undefined;
}

export const recipeTypePageMetadataByPath: Record<
    string,
    { title: string; description: string; coverImageUrl: string }
> = {
    breakfast: {
        title: "Breakfast",
        description: "",
        coverImageUrl: "/default-breakfast.jpg"
    },
    snack: {
        title: "Snack",
        description: "",
        coverImageUrl: "/default-snack.jpg"
    },
    appetizer: {
        title: "Appetizer",
        description: "",
        coverImageUrl: "/default-appetizer.jpg"
    },
    main: {
        title: "Main Course",
        description: "",
        coverImageUrl: "/default-main.jpg"
    },
    side: {
        title: "Side",
        description: "",
        coverImageUrl: "/default-side.jpg"
    },
    soup: {
        title: "Soup",
        description: "",
        coverImageUrl: "/default-soup.jpg"
    },
    bread: {
        title: "Bread",
        description: "",
        coverImageUrl: "/default-bread.jpg"
    },
    "sauces-and-seasonings": {
        title: "Sauces and Seasonings",
        description: "",
        coverImageUrl: "/default-seasonings.jpg"
    },
    dessert: {
        title: "Dessert",
        description: "",
        coverImageUrl: "/default-dessert.jpg"
    },
    drink: {
        title: "Drink",
        description: "",
        coverImageUrl: "/default-drink.jpg"
    }
};

export function getRecipeTypePageMetadata(recipeType: RecipeType | undefined): {
    title: string;
    description: string;
    coverImageUrl: string;
} {
    const recipesPageDefault = {
        title: "All Spells in the Book",
        description: "Search and filter the recipes you've gathered.",
        coverImageUrl: "/manual.png"
    };
    if (!recipeType) return recipesPageDefault;
    return recipeTypePageMetadataByPath[recipeTypeToPath(recipeType) || ""] || recipesPageDefault;
}
